import { render } from "./UserDirectory.vue?vue&type=template&id=0d81cc96"
import script from "./UserDirectory.vue?vue&type=script&lang=js"
export * from "./UserDirectory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__